/* unplugin-vue-components disabled */import { render } from "./sh-companies.vue?vue&type=template&id=28b7813b&scoped=true"
import script from "./sh-companies.vue?vue&type=script&lang=js"
export * from "./sh-companies.vue?vue&type=script&lang=js"

import "./sh-companies.vue?vue&type=style&index=0&id=28b7813b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b7813b"],['__file',"src/pages/sh-companies/sh-companies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28b7813b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28b7813b', __exports__)) {
    api.reload('28b7813b', __exports__)
  }
  
  module.hot.accept("./sh-companies.vue?vue&type=template&id=28b7813b&scoped=true", () => {
    api.rerender('28b7813b', render)
  })

}


export default __exports__